<template>
  <el-container class="bi-layout">
    <el-header class="nav-container" :height="isMobile ? 'auto' : '60px'">
      <navbar nav-index="/bi" @nav-items-click="navClick" />
    </el-header>
    <el-container>
      <sidebar :items="biRouters" class="sidebar-container" />
      <el-main id="crm-main-container">
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Navbar, Sidebar, AppMain } from "./components";

export default {
  name: "BiLayout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["isMobile"]),
    ...mapGetters(["biRouters"]),
  },
  methods: {
    navClick(index) {},
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/common.scss";
@media screen and (max-width: 768px) {
  .bi-layout {
    .nav-container {
      z-index: 10000 !important;
    }
    #crm-main-container {
      width: 100vw !important;
      padding: 2.6667vw 0 !important;
    }
  }
}
@media screen and (min-width: 769px) {
  .nav-container {
    min-width: 1200px;
  }
}
.aside-container {
  position: relative;
  background-color: #2d3037;
  box-sizing: border-box;
}

.nav-container {
  padding: 0;
  box-shadow: 0px 1px 2px #dbdbdb;
  z-index: 100;
  min-width: 1200px;
}

.el-container {
  overflow: hidden;
  height: 100%;
}
</style>
